import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestRefundRegister from './request/requestRefundRegister'

const Actions = {
  // RF01 返金履歴取得
  getRefundListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.REFUND_LIST)
      .get(api.REFUND_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.REFUND_SET_REFUND_LIST
        commit(path, response.data.data)
        const getData = getters.getRefundListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // RF02 返金登録
  registerRefund: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestRefundRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.REFUND_REGISTER)
      .post(`${api.REFUND_REGISTER}/${params.refundData.saleId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // RF03 返金キャンセル
  cancelRefund: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.REFUND_REGISTER_CANCEL)
      .patch(`${api.REFUND_REGISTER_CANCEL}/${params.refundId}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
